<bizz-status-icon [statusType]="data['Read'] ? TaskStateType.Completed : TaskStateType.Open"></bizz-status-icon>